var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"width":"100%","margin-top":"-15px","margin-bottom":"15px"},attrs:{"src":_vm.imgUrl}}),_c('BreadCrumb'),_c('router-view',{key:_vm.$route.path})],1)}
var staticRenderFns = []

export { render, staticRenderFns }